import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { storeUserInfo, loadingStatus, setViewAs } from "../../actions"
import BuildForm from "../../helpers/buildForm"
import axios from "axios"
import settings from "settings"
import { Redirect } from "react-router"
import { Link } from "react-router-dom"

class Login extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields: [
				{
					label: "Email",
					id: "email",
					type: "email",
					validate: ["required", "email"],
					help: "This field is required.",
					value: "",
					valid: false,
				},
				{
					label: "Password",
					id: "password",
					type: "password",
					validate: ["required"],
					help: "This field is required.",
					value: "",
					valid: false,
					error: false,
				},
			],
			valid: false,
			loginValid: false,
			errorMessage: "",
			loginPath: "",
		}
	}

	updateValue = (id, value) => {
		var state = this.state
		state.fields.map((r) => {
			if (r.id == id) {
				r.value = value
			}
		})

		this.setState(state, () => {
			//console.log(this.state)
		})
	}

	setValid = (id, bool) => {
		var state = this.state
		state.fields.map((r) => {
			if (r.id == id) {
				r.valid = bool
			}
		})

		var valid = true
		state.fields.map((r) => {
			if (r.valid === false) {
				valid = false
			}
		})

		if (valid === true) {
			state.valid = true
			this.setState(state)
		} else {
			state.valid = false
			this.setState(state)
		}
	}

	_handleSubmit = (e) => {
		e.preventDefault()
		if (this.state.valid) {
			// throw up loading
			this.props.loadingStatus(true)
			//IDs of column names should match
			var qs = require("qs")
			var data = {
				email: this.state.fields[0].value,
				password: this.state.fields[1].value,
			}
			axios
				.post(settings.ep + "/login", data)
				.then((response) => {
					if (response.data.status == 200) {
						var jwtDecode = require("jwt-decode")
						var user = jwtDecode(response.data.token)
						var loginPath = ""
						if (user.aud == 1) {
							loginPath = "/entry/dashboard"
						} else if (user.aud == 2) {
							loginPath = "/salesManager/dashboard"
						} else if (user.group == 14) [(loginPath = "/arc")]
						else if(user.group === 15) {
							loginPath = "/superintendent/lot-inventory"
						}
						else {
							loginPath = "/"
						}
						localStorage.setItem("user", response.data.token)

						this.props.loadingStatus(false)
						this.props.setViewAs(0)
						this.setState({ loginValid: true, loginPath: loginPath })
					} else {
						this.props.loadingStatus(false)
						this.setState({ error: true, errorMessage: response.data.message })
					}
				})
				.catch((error) => {
					console.log(error)
				})
		} else {
			// This is where issue#1 should go

			console.log("not valid")
		}
	}

	render() {
		var classNames = require("classnames")
		var submitClasses = classNames(`cursor-pointer`, "form__submit", {
			"form__submit--ready": this.state.valid,
		})
		var errorClass = classNames("form__error", {
			"form__error--active": this.state.error,
		})
		if (this.state.loginValid) {
			return <Redirect to={this.state.loginPath} />
		} else {
			return (
				<div className="login">
					<div>
						<img src={settings.logo} className="login__logo" />
						<form onSubmit={this._handleSubmit} className="login__form">
							<p className={errorClass}>{this.state.errorMessage}</p>
							<ul className="login__list">
								<BuildForm
									fields={this.state.fields}
									setValid={this.setValid}
									updateValue={this.updateValue}
								/>
							</ul>
							<input type="submit" value="Submit" className={submitClasses} />
							<p className="small" style={{ marginTop: 25 }}>
								<Link to="/forgot-password">Reset Password</Link>
							</p>
						</form>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		loggedInUser: state.loggedInUser,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			storeUserInfo: storeUserInfo,
			loadingStatus: loadingStatus,
			setViewAs,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(Login)
